import { min, max } from 'd3-array';

import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';

/** Price Channel indicator */
export default class PriceChannelIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} componentSeries - Indicator component series
	 */
	_getDefaultParams() {
		return {
			id: 'pricechannel',
			name: 'Price Channel',
			description:
				'Price Channel is a trending indicator that shows the high and low prices for a period. It is typically a bullish signal, when a stock breaks out above the prior high for a period.',
			inputs: [{ name: 'period', value: 20 }],
			componentSeries: [
				{ id: 'pricechannellower' },
				{ id: 'pricechannelupper' }
			]
		};
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range minimum
	 */
	getRangeMin(data) {
		return min(data.pricechannel || [], i => +i.pricechannellower);
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range maximum
	 */
	getRangeMax(data) {
		return max(data.pricechannel || [], i => +i.pricechannelupper);
	}

	/**
	 * @return {object}
	 * @property {LineMarker} lineUp
	 * @property {LineMarker} lineDown
	 * @property {LineMarker} lineFill
	 */
	_getMarkers() {
		return (
			this.markers || {
				lineUp: new LineMarker(),
				lineDown: new LineMarker(),
				lineFill: new LineMarker()
			}
		);
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		const dataUp = this._getDataMap(data.pricechannel, 'pricechannelupper');
		const dataDown = this._getDataMap(data.pricechannel, 'pricechannellower');

		this.markers.lineFill.renderFillBetween(
			this.panel.rootContext,
			dataUp,
			dataDown,
			this.xScale,
			this.yScale,
			this.params.style.background.color
		);

		this._renderLineMarker({
			dataMap: dataUp,
			marker: this.markers.lineUp,
			sessionType
		});

		this._renderLineMarker({
			dataMap: dataDown,
			marker: this.markers.lineDown,
			sessionType
		});
	}
}
